import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import "./DonutChart.css"; // Custom styles
import { useTranslation } from "react-i18next";
ChartJS.register(ArcElement, Tooltip, Legend);

const DonutChart = ({overview}) => {
  const { t, i18n } = useTranslation();
  const data = {
    labels: ["Missed Questions", "Correct Answers", "Wrong Answers"],
    datasets: [
      {
        data: [overview.missed_percentage, overview.correct_percentage, overview.wrong_percentage], // Percentages
        backgroundColor: ["#4D92D8", "#12823F", "#ED9625"],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    cutout: "70%", // Creates the donut effect
    plugins: {
      legend: { display: false }, // Hide default legend
      datalabels: {
        display: false,
    
      },
      tooltip: {
        enabled: false, // Disable default tooltip
        external: function (context) {
          // Get tooltip element
          let tooltipEl = document.getElementById("chartjs-tooltip");

          // Create tooltip element if it doesn't exist
          if (!tooltipEl) {
            tooltipEl = document.createElement("div");
            tooltipEl.id = "chartjs-tooltip";
            tooltipEl.innerHTML = "<table></table>";
            document.body.appendChild(tooltipEl);
          }

          // Hide if no tooltip
          const tooltipModel = context.tooltip;
          if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = "0";
            return;
          }

          // Set content of tooltip
          if (tooltipModel.body) {
            const bodyLines = tooltipModel.body.map((b) => b.lines);
            let innerHtml = "<thead>";
      
            bodyLines.forEach((body, i) => {
              const dataPoint = tooltipModel.dataPoints[0]; // Get the first (and only) tooltip data point
              const label = data.labels[dataPoint.dataIndex];
              let value = tooltipModel.dataPoints[i].raw + "%";
      
              // Define colors based on category
              let bgColor = "";
              let fontColor = "";
      
              if (label === "Missed Questions") {
                bgColor = "#E2F8FC";
                fontColor = "#4D92D8";
              } else if (label === "Correct Answers") {
                bgColor = "#E6F6EB";
                fontColor = "#12823F";
              } else if (label === "Wrong Answers") {
                bgColor = "#FCF2E1";
                fontColor = "#ED9625";
              }
      
              innerHtml += `
                <tr class="tooltip-label" style="background:${bgColor}; color:${fontColor}; padding:5px; border-radius:5px;">
                  <td style="font-weight:bold;">${value}</td>
                  <td>${t(label)}</td>
                </tr>
              `;
            });
      
            innerHtml += "</thead>";
            let tableRoot = tooltipEl.querySelector("table");
            tableRoot.innerHTML = innerHtml;
          }

          // Position the tooltip
          const position = context.chart.canvas.getBoundingClientRect();
          tooltipEl.style.opacity = "1";
          tooltipEl.style.position = "absolute";
          tooltipEl.style.left = position.left + window.scrollX + tooltipModel.caretX + "px";
          tooltipEl.style.top = position.top + window.scrollY + tooltipModel.caretY + "px";
          tooltipEl.style.padding = "6px";
          tooltipEl.style.pointerEvents = "none";
        },
      },
    },
  };

  return (
    <div className="donut-chart-container">
      <h3 className="chart-title">{t('Result')}:</h3>
      <div className="donut-chart">
        <Doughnut data={data} options={options} />
        {/* Labels positioned outside the chart */}
     
      </div>
      {/* Legend below the chart */}
      <div className="chart-legend">
        <div className="legend-item">
          <span className="legend-color missed"></span> {t('Missed Questions')}
        </div>
        <div className="legend-item">
          <span className="legend-color correct"></span> {t('Correct Answers')}
        </div>
        <div className="legend-item">
          <span className="legend-color wrong"></span> {t('Wrong Answers')}
        </div>
      </div>
    </div>
  );
};

export default DonutChart;
